var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoDarkBackground = function SvgInfoDarkBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#003E52",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.02c.84 0 1.52-.68 1.52-1.52S12.84 4 12 4c-.82 0-1.5.66-1.5 1.5s.68 1.52 1.5 1.52Zm1.28 10.7V8.06h-2.54v9.66h2.54Z",
    fill: "#FFF"
  }))));
};
export default SvgInfoDarkBackground;